import { render, staticRenderFns } from "./ListNonManagers.vue?vue&type=template&id=ed6801fa&scoped=true&"
import script from "./ListNonManagers.vue?vue&type=script&lang=js&"
export * from "./ListNonManagers.vue?vue&type=script&lang=js&"
import style0 from "./ListNonManagers.vue?vue&type=style&index=0&id=ed6801fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed6801fa",
  null
  
)

export default component.exports